import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, unref as _unref, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "formulario-modelo" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "header-flex" }
const _hoisted_4 = {
  key: 0,
  class: "ctx-modelo"
}
const _hoisted_5 = {
  key: 1,
  class: "escala-rango-hint"
}
const _hoisted_6 = { class: "acciones-header" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "selector-proceso"
}
const _hoisted_9 = { class: "selector-procesos-lista" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "proceso-nombre" }
const _hoisted_12 = { class: "proceso-periodo" }
const _hoisted_13 = {
  key: 1,
  class: "proceso-activo-banner"
}
const _hoisted_14 = {
  key: 1,
  class: "aviso-sin-proceso"
}
const _hoisted_15 = {
  key: 2,
  class: "filtros-bar"
}
const _hoisted_16 = {
  key: 0,
  class: "filtro-grupo"
}
const _hoisted_17 = { class: "filtro-label" }
const _hoisted_18 = ["value"]
const _hoisted_19 = {
  key: 1,
  class: "filtro-grupo"
}
const _hoisted_20 = { class: "filtro-label" }
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "indicadores-container" }
const _hoisted_23 = {
  key: 0,
  class: "sin-indicadores"
}
const _hoisted_24 = {
  key: 1,
  class: "sin-indicadores"
}
const _hoisted_25 = {
  key: 0,
  class: "nivel-1-header"
}
const _hoisted_26 = { class: "nivel-badge-label n1-badge" }
const _hoisted_27 = { class: "nivel-ordinal" }
const _hoisted_28 = { class: "nivel-nombre" }
const _hoisted_29 = { class: "indicador-card-main" }
const _hoisted_30 = { class: "indicador-card-header" }
const _hoisted_31 = { class: "indicador-nombre" }
const _hoisted_32 = {
  key: 1,
  class: "componente-nombre"
}
const _hoisted_33 = {
  key: 0,
  class: "indicador-card-body"
}
const _hoisted_34 = {
  key: 0,
  class: "indicador-info-item"
}
const _hoisted_35 = { class: "info-text" }
const _hoisted_36 = {
  key: 1,
  class: "indicador-info-item"
}
const _hoisted_37 = { class: "info-text" }
const _hoisted_38 = {
  key: 2,
  class: "indicador-info-item"
}
const _hoisted_39 = { class: "info-text" }
const _hoisted_40 = { class: "indicador-card-accion" }
const _hoisted_41 = {
  key: 0,
  class: "nota-inline-contenedor nota-inline-bloqueado"
}
const _hoisted_42 = ["value"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = {
  key: 1,
  class: "nota-inline-contenedor"
}
const _hoisted_45 = ["min", "max", "onUpdate:modelValue", "placeholder", "onChange"]
const _hoisted_46 = ["disabled", "onClick"]
const _hoisted_47 = {
  key: 2,
  class: "nota-inline-contenedor"
}
const _hoisted_48 = ["min", "max", "onUpdate:modelValue", "placeholder", "onChange"]
const _hoisted_49 = { class: "nota-etiqueta-valor" }
const _hoisted_50 = ["disabled", "onClick"]
const _hoisted_51 = ["disabled", "onClick"]
const _hoisted_52 = { class: "nivel-2-header" }
const _hoisted_53 = { class: "nivel-badge-label n2-badge" }
const _hoisted_54 = { class: "nivel-ordinal" }
const _hoisted_55 = { class: "nivel-nombre" }
const _hoisted_56 = { class: "nivel-body" }
const _hoisted_57 = { class: "indicador-card-main" }
const _hoisted_58 = { class: "indicador-card-header" }
const _hoisted_59 = { class: "indicador-nombre" }
const _hoisted_60 = {
  key: 1,
  class: "componente-nombre"
}
const _hoisted_61 = {
  key: 0,
  class: "indicador-card-body"
}
const _hoisted_62 = {
  key: 0,
  class: "indicador-info-item"
}
const _hoisted_63 = { class: "info-text" }
const _hoisted_64 = {
  key: 1,
  class: "indicador-info-item"
}
const _hoisted_65 = { class: "info-text" }
const _hoisted_66 = {
  key: 2,
  class: "indicador-info-item"
}
const _hoisted_67 = { class: "info-text" }
const _hoisted_68 = { class: "indicador-card-accion" }
const _hoisted_69 = {
  key: 0,
  class: "nota-inline-contenedor nota-inline-bloqueado"
}
const _hoisted_70 = ["value"]
const _hoisted_71 = ["onClick"]
const _hoisted_72 = {
  key: 1,
  class: "nota-inline-contenedor"
}
const _hoisted_73 = ["min", "max", "onUpdate:modelValue", "placeholder", "onChange"]
const _hoisted_74 = ["disabled", "onClick"]
const _hoisted_75 = {
  key: 2,
  class: "nota-inline-contenedor"
}
const _hoisted_76 = ["min", "max", "onUpdate:modelValue", "placeholder", "onChange"]
const _hoisted_77 = { class: "nota-etiqueta-valor" }
const _hoisted_78 = ["disabled", "onClick"]
const _hoisted_79 = ["disabled", "onClick"]
const _hoisted_80 = { class: "nivel-3-header" }
const _hoisted_81 = { class: "nivel-badge-label n3-badge" }
const _hoisted_82 = { class: "nivel-ordinal" }
const _hoisted_83 = { class: "nivel-nombre" }
const _hoisted_84 = { class: "indicador-card-main" }
const _hoisted_85 = { class: "indicador-card-header" }
const _hoisted_86 = { class: "indicador-nombre" }
const _hoisted_87 = {
  key: 1,
  class: "componente-nombre"
}
const _hoisted_88 = {
  key: 0,
  class: "indicador-card-body"
}
const _hoisted_89 = {
  key: 0,
  class: "indicador-info-item"
}
const _hoisted_90 = { class: "info-text" }
const _hoisted_91 = {
  key: 1,
  class: "indicador-info-item"
}
const _hoisted_92 = { class: "info-text" }
const _hoisted_93 = {
  key: 2,
  class: "indicador-info-item"
}
const _hoisted_94 = { class: "info-text" }
const _hoisted_95 = { class: "indicador-card-accion" }
const _hoisted_96 = {
  key: 0,
  class: "nota-inline-contenedor nota-inline-bloqueado"
}
const _hoisted_97 = ["value"]
const _hoisted_98 = ["onClick"]
const _hoisted_99 = {
  key: 1,
  class: "nota-inline-contenedor"
}
const _hoisted_100 = ["min", "max", "onUpdate:modelValue", "placeholder", "onChange"]
const _hoisted_101 = ["disabled", "onClick"]
const _hoisted_102 = {
  key: 2,
  class: "nota-inline-contenedor"
}
const _hoisted_103 = ["min", "max", "onUpdate:modelValue", "placeholder", "onChange"]
const _hoisted_104 = { class: "nota-etiqueta-valor" }
const _hoisted_105 = ["disabled", "onClick"]
const _hoisted_106 = ["disabled", "onClick"]
const _hoisted_107 = { class: "botones-inferior" }
const _hoisted_108 = ["disabled"]
const _hoisted_109 = {
  key: 1,
  class: "modal-confirm-overlay"
}
const _hoisted_110 = { class: "modal-confirm" }
const _hoisted_111 = { class: "modal-confirm-botones" }
const _hoisted_112 = {
  key: 2,
  class: "modal-overlay"
}
const _hoisted_113 = { class: "modal-contenido" }
const _hoisted_114 = { class: "modal-body-scroll" }

import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import LoadingOverlay from '@/components/LoadingOverlay.vue'
import MensajeFlotante from '@/components/MensajeFlotante.vue'
import CalificarIndicadorUnificadoModal from '@/components/CalificarIndicadorUnificadoModal.vue'
import { useComponentes } from '@/store/GestionComponentes'
import { useGestionVersiones } from '@/store/GestionVersiones'
import useModelo from '@/store/GestionModelo'
import { useGestionIndicadores } from '@/store/GestionIndicadores'
import { useGestionEvaluacionesIndicadores } from '@/store/GestionEvaluacionesIndicadores'
import { useGestionProcesos } from '@/store/GestionProcesoAutoevaluacion'
import useAutenticar from '@/store/IngresoAutenticar'
import type Componente from '@/interfaces/Componente'
import type Version from '@/interfaces/Versiones'
import type EstructuraModelo from '@/interfaces/EstructuraModelo'
import type Indicador from '@/interfaces/Indicador'
import { limpiarNiveles } from '@/utils/nivelesHelper'
import { useAsignacionActual } from '@/composables/useAsignacionActual'
import { useGestionIndicadorEvaluadores } from '@/store/GestionIndicadorEvaluadores'
import { useGestionIndicadorInstrumentos } from '@/store/GestionIndicadorInstrumentos'

interface GrupoComponente {
  nombre: string
  ordinal: string
  ancestros: string[]
  ordinalesAncestros: string[]
  indicadores: Indicador[]
}

interface NodoArbol {
  nombre: string
  ordinal: string
  nivel: number
  hijos: NodoArbol[]
  indicadores: Indicador[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ListadoCalificar',
  setup(__props) {

/**
 * Listado de indicadores pendientes de calificar.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

const route = useRoute()
const router = useRouter()
const componentesStore = useComponentes()
const versionesStore = useGestionVersiones()
const modeloStore = useModelo()
const indicadoresStore = useGestionIndicadores()
const evaluacionesStore = useGestionEvaluacionesIndicadores()
const procesosStore = useGestionProcesos()
const authStore = useAutenticar()
const { necesitaFiltro, idsIndicadores } = useAsignacionActual()
const evaluadoresStore = useGestionIndicadorEvaluadores()
const indicadorInstrumentoStore = useGestionIndicadorInstrumentos()
const idVersion = Number(route.params.id_version ?? NaN)
const idUsuario = computed(() => authStore.usuarioActual?.id ?? null)
const procesosEnEvaluacion = computed(() =>
  procesosStore.procesos.filter(p => p.id_version === idVersion && p.estado === 'evaluacion')
)
const idProcesoSeleccionado = ref<number | null>(null)
const procesoSeleccionado = computed(() =>
  procesosEnEvaluacion.value.find(p => p.id === idProcesoSeleccionado.value) ?? null
)

const hoy = new Date().toISOString().split('T')[0]

const loading = ref(false)
const nombreVersion = ref('')
const idComponenteRaiz = ref<number | null>(null)
const nivelesArray = ref<string[]>([])
const indicadoresDeLaVersion = ref<Indicador[]>([])
const nombreComponentePorIndicador = ref<Record<number, string>>({})
const nivelComponentePorIndicador = ref<Record<number, number>>({})
const ancestoresPorIndicador = ref<Record<number, string[]>>({})
const ordinalComponentePorIndicador = ref<Record<number, string>>({})
const ordinalesAncestoresPorIndicador = ref<Record<number, string[]>>({})

function formatOrdinal(ordinal: string): string {
  if (!ordinal) return ''
  const parts = ordinal.split('.')
  return parts.length > 1 ? parts.slice(1).join('.') : ordinal
}

// Feedback
const mensajeVisible = ref(false)
const mensajeTexto = ref('')
const mensajeTipo = ref<'positivo' | 'error'>('positivo')

function mostrarExito(msg: string) {
  mensajeTexto.value = msg
  mensajeTipo.value = 'positivo'
  mensajeVisible.value = true
}
function mostrarError(msg: string) {
  mensajeTexto.value = msg
  mensajeTipo.value = 'error'
  mensajeVisible.value = true
}

// Estado notas inline
const notasLocales = ref<Record<number, number | null>>({})
const guardadoFinal = ref(false)
const guardandoNotas = ref(false)
const modalConfirmVisible = ref(false)
const indicadoresEnEdicion = ref<number[]>([])
const guardandoModificacion = ref(false)

function habilitarEdicionInline(id: number) {
  if (!indicadoresEnEdicion.value.includes(id)) {
    indicadoresEnEdicion.value = [...indicadoresEnEdicion.value, id]
  }
}

async function guardarModificacionInline(indicador: Indicador) {
  const id = indicador.id_indicador!
  const rawVal = notasLocales.value[id]
  if (rawVal == null) {
    mostrarError('Ingrese una nota antes de guardar.')
    return
  }
  if (!idUsuario.value) {
    mostrarError('No se puede guardar: usuario no identificado. Vuelva a iniciar sesión.')
    return
  }
  if (!idProcesoSeleccionado.value) {
    mostrarError('Seleccione un proceso antes de guardar.')
    return
  }
  const nota = Math.min(Math.max(Number(rawVal), escalaMin.value), escalaMax.value)
  guardandoModificacion.value = true

  const resultado = await evaluacionesStore.guardarBulk({
    id_version: idVersion,
    id_ejecucion: idProcesoSeleccionado.value,
    id_usuario: Number(idUsuario.value),
    fecha_evaluacion: hoy,
    observaciones: '-',
    justificacion: '-',
    evaluaciones: [{
      id_indicador: id,
      calificacion_documental: nota,
      calificacion_cuantitativa: nota,
      calificacion_opinion: nota
    }]
  })

  guardandoModificacion.value = false

  if (!resultado.ok || resultado.errores.length > 0) {
    mostrarError('No se pudo actualizar la nota. Intente de nuevo.')
    return
  }

  indicadoresEnEdicion.value = indicadoresEnEdicion.value.filter(i => i !== id)
  await evaluacionesStore.cargar({ id_version: idVersion })
  llenarNotasLocales()
  mostrarExito('Nota actualizada correctamente.')
}
const escalaMax = ref<5 | 10>(5)
const escalaMin = computed(() => escalaMax.value === 10 ? 1 : 0)

function clampNota(id: number) {
  const v = notasLocales.value[id]
  if (v == null) return
  const min = escalaMax.value === 10 ? 1 : 0
  if (v < min) notasLocales.value[id] = min
  else if (v > escalaMax.value) notasLocales.value[id] = escalaMax.value
}


// Recorre el árbol ya cargado y asigna indicadores desde el store (sin HTTP)
function recopilarIndicadoresDesdeStore(nodos: Componente[]): Indicador[] {
  const hojas: { nodo: Componente; profundidad: number; ancestros: string[]; ordinalesAncestros: string[] }[] = []

  function recopilarHojas(lista: Componente[], profundidad: number, ancestros: string[], ordinalesAncestros: string[]) {
    const ordenados = [...lista].sort((a, b) =>
      (a.ordinal ?? '').localeCompare(b.ordinal ?? '', undefined, { numeric: true })
    )
    for (const nodo of ordenados) {
      if (nodo.children?.length) {
        recopilarHojas(
          nodo.children,
          profundidad + 1,
          [...ancestros, nodo.nombre],
          [...ordinalesAncestros, formatOrdinal(nodo.ordinal ?? '')]
        )
      } else if (nodo.id_componente) {
        hojas.push({ nodo, profundidad, ancestros, ordinalesAncestros })
      }
    }
  }
  recopilarHojas(nodos, 0, [], [])

  const resultado: Indicador[] = []
  const idsVistos = new Set<number>()
  for (const { nodo, profundidad, ancestros, ordinalesAncestros } of hojas) {
    const inds = indicadoresStore.indicadores.filter(
      i => i.id_componente === nodo.id_componente && i.id_version === idVersion && i.id_indicador != null
    )
    for (const ind of inds) {
      if (!idsVistos.has(ind.id_indicador!)) {
        idsVistos.add(ind.id_indicador!)
        resultado.push(ind)
        nombreComponentePorIndicador.value[ind.id_indicador!] = nodo.nombre
        nivelComponentePorIndicador.value[ind.id_indicador!] = profundidad
        ancestoresPorIndicador.value[ind.id_indicador!] = ancestros
        ordinalComponentePorIndicador.value[ind.id_indicador!] = formatOrdinal(nodo.ordinal ?? '')
        ordinalesAncestoresPorIndicador.value[ind.id_indicador!] = ordinalesAncestros
      }
    }
  }
  return resultado
}

onMounted(async () => {
  loading.value = true
  try {
    const version = await versionesStore.getVersionById(idVersion) as Version | null
    nombreVersion.value = version?.nombre ?? ''
    const idModelo = version?.id_modelo ?? null
    if (!idModelo) return

    // Modelo, raíz de componentes, evaluaciones, proceso activo e indicadores en paralelo
    const [modelo, raiz] = await Promise.all([
      modeloStore.getModeloById(idModelo) as Promise<EstructuraModelo | null>,
      componentesStore.cargarRaizPorModelo(idModelo),
      evaluacionesStore.cargar({ id_version: idVersion }),
      procesosStore.cargarTodos({ id_version: idVersion }),
      indicadoresStore.cargarTodos(),
      indicadorInstrumentoStore.getRelaciones()
    ])

    if (modelo?.niveles) {
      nivelesArray.value = limpiarNiveles(modelo.niveles)
    }
    if (modelo?.escala_max) {
      escalaMax.value = modelo.escala_max as 5 | 10
    }

    if (raiz?.id_componente) {
      idComponenteRaiz.value = raiz.id_componente
      await componentesStore.cargarArbolDesdeRaiz(raiz.id_componente)
    }

    // Auto-seleccionar si la versión tiene un único proceso en evaluación
    if (procesosEnEvaluacion.value.length === 1) {
      idProcesoSeleccionado.value = procesosEnEvaluacion.value[0].id ?? null
    }

    const raizNodo = componentesStore.componentes[0]
    if (raizNodo?.children?.length) {
      indicadoresDeLaVersion.value = recopilarIndicadoresDesdeStore(raizNodo.children)
    }

    llenarNotasLocales()
  } finally {
    loading.value = false
  }
})

const todosLosIndicadores = computed<Indicador[]>(() => {
  // Prioridad: asignaciones específicas de tarea 'calificar' para esta versión
  const tareasCalificar = evaluadoresStore.misAsignaciones.filter(
    a => a.tarea === 'calificar' && a.id_indicador != null && a.id_version === idVersion
  )
  if (tareasCalificar.length > 0) {
    const ids = new Set(tareasCalificar.map(a => a.id_indicador as number))
    return indicadoresDeLaVersion.value.filter(
      ind => ind.id_indicador != null && ids.has(ind.id_indicador)
    )
  }
  if (!necesitaFiltro.value) return indicadoresDeLaVersion.value
  return indicadoresDeLaVersion.value.filter(
    ind => ind.id_indicador != null && idsIndicadores.value.includes(ind.id_indicador)
  )
})

const gruposConIndicadores = computed<GrupoComponente[]>(() => {
  const grupos: GrupoComponente[] = []
  for (const ind of todosLosIndicadores.value) {
    const comp = nombreComponentePorIndicador.value[ind.id_indicador!] ?? ''
    const ultimo = grupos[grupos.length - 1]
    if (!ultimo || ultimo.nombre !== comp) {
      grupos.push({
        nombre: comp,
        ordinal: ordinalComponentePorIndicador.value[ind.id_indicador!] ?? '',
        ancestros: ancestoresPorIndicador.value[ind.id_indicador!] ?? [],
        ordinalesAncestros: ordinalesAncestoresPorIndicador.value[ind.id_indicador!] ?? [],
        indicadores: [ind]
      })
    } else {
      ultimo.indicadores.push(ind)
    }
  }
  return grupos
})

const arbolParaVista = computed<NodoArbol[]>(() => {
  const raices: NodoArbol[] = []
  for (const grupo of gruposConIndicadores.value) {
    const camino = [...grupo.ancestros, grupo.nombre]
    const ordinalesCamino = [...grupo.ordinalesAncestros, grupo.ordinal]
    let nivelActual = raices
    let nodoActual: NodoArbol | undefined
    for (let i = 0; i < camino.length; i++) {
      let nodo = nivelActual.find(n => n.nombre === camino[i])
      if (!nodo) {
        nodo = { nombre: camino[i], ordinal: ordinalesCamino[i] ?? '', nivel: i, hijos: [], indicadores: [] }
        nivelActual.push(nodo)
      }
      nodoActual = nodo
      if (i < camino.length - 1) nivelActual = nodo.hijos
    }
    if (nodoActual) nodoActual.indicadores.push(...grupo.indicadores)
  }
  return raices
})

// Filtros por nivel 
const filtroN1 = ref<string | null>(null)
const filtroN2 = ref<string | null>(null)

const opcionesN1 = computed(() => arbolParaVista.value.map(n => n.nombre))

const opcionesN2 = computed(() => {
  const base = filtroN1.value
    ? arbolParaVista.value.filter(n => n.nombre === filtroN1.value)
    : arbolParaVista.value
  const vistos = new Set<string>()
  for (const n1 of base) {
    for (const n2 of n1.hijos) vistos.add(n2.nombre)
  }
  return [...vistos]
})

const arbolFiltrado = computed<NodoArbol[]>(() => {
  let arbol = arbolParaVista.value
  if (filtroN1.value) {
    arbol = arbol.filter(n1 => n1.nombre === filtroN1.value)
  }
  if (filtroN2.value) {
    arbol = arbol
      .map(n1 => ({ ...n1, hijos: n1.hijos.filter(n2 => n2.nombre === filtroN2.value) }))
      .filter(n1 => n1.hijos.length > 0 || n1.indicadores.length > 0)
  }
  return arbol
})

function onCambioN1() {
  filtroN2.value = null
}

// true = sin instrumento vinculado → modo histórico (input inline)
// false = tiene instrumento → modo normal (botón Calificar)
const mismoNombrePorIndicador = computed<Record<number, boolean>>(() => {
  const idsConInstrumento = new Set(
    indicadorInstrumentoStore.relaciones.map(r => Number(r.id_indicador))
  )
  const mapa: Record<number, boolean> = {}
  for (const ind of indicadoresDeLaVersion.value) {
    if (ind.id_indicador == null) continue
    mapa[ind.id_indicador] = !idsConInstrumento.has(ind.id_indicador)
  }
  return mapa
})

const tieneIndicadoresInline = computed(() =>
  todosLosIndicadores.value.some(
    ind => ind.id_indicador != null && mismoNombrePorIndicador.value[ind.id_indicador]
  )
)

const todasLasNotasInlineRegistradas = computed(() => {
  if (!idProcesoSeleccionado.value) return false
  const inline = todosLosIndicadores.value.filter(
    ind => ind.id_indicador != null && mismoNombrePorIndicador.value[ind.id_indicador!]
  )
  return inline.length > 0 && inline.every(
    ind => evaluacionPorIndicador.value[ind.id_indicador!] != null
  )
})

function llenarNotasLocales(): void {
  notasLocales.value = {}
  for (const ev of evaluacionesStore.evaluaciones) {
    if (idProcesoSeleccionado.value !== null && ev.id_ejecucion !== idProcesoSeleccionado.value) continue
    if (ev.id_indicador != null && ev.calificacion_final != null) {
      notasLocales.value[ev.id_indicador] = ev.calificacion_final
    }
  }
}

function seleccionarProceso(id: number): void {
  idProcesoSeleccionado.value = id
  guardadoFinal.value = false
  llenarNotasLocales()
}

// Modal calificar (modo normal)
const modalIndicadorVisible = ref(false)
const indicadorSeleccionado = ref<number | null>(null)

function onCalificarIndicador(indicador: Indicador) {
  if (!indicador?.id_indicador) return
  indicadorSeleccionado.value = indicador.id_indicador
  modalIndicadorVisible.value = true
}

async function cerrarModalIndicador() {
  modalIndicadorVisible.value = false
  indicadorSeleccionado.value = null
  await evaluacionesStore.cargar({ id_version: idVersion })
  llenarNotasLocales()
}

const evaluacionPorIndicador = computed(() => {
  const mapa: Record<number, number | null | undefined> = {}
  for (const ev of evaluacionesStore.evaluaciones) {
    if (ev.id_indicador == null) continue
    // Cuando hay proceso seleccionado, solo contar evaluaciones de ESE proceso
    if (idProcesoSeleccionado.value !== null && ev.id_ejecucion !== idProcesoSeleccionado.value) continue
    // Usar la nota final; si el backend aún no la calculó, caer a cualquier sub-nota registrada
    const nota = ev.calificacion_final ?? ev.calificacion_documental ?? ev.calificacion_cuantitativa ?? ev.calificacion_opinion
    mapa[ev.id_indicador] = nota ?? null
  }
  return mapa
})

// Guardar todas las notas inline
async function confirmarGuardar() {
  modalConfirmVisible.value = false

  if (!idUsuario.value) {
    mostrarError('No se puede guardar: usuario no identificado. Vuelva a iniciar sesión.')
    return
  }

  if (!idProcesoSeleccionado.value) {
    mostrarError('Seleccione un proceso antes de guardar.')
    return
  }

  // Solo indicadores inline con nota explícitamente ingresada (rawVal no nulo)
  const indicadoresInline = todosLosIndicadores.value.filter(
    ind => ind.id_indicador != null && mismoNombrePorIndicador.value[ind.id_indicador!]
  )

  const evaluacionesPayload = indicadoresInline
    .filter(ind => notasLocales.value[ind.id_indicador!] != null)
    .map(ind => {
      const rawVal = notasLocales.value[ind.id_indicador!]!
      const min = escalaMin.value
      const nota = Math.min(Math.max(Number(rawVal), min), escalaMax.value)
      return {
        id_indicador: ind.id_indicador!,
        calificacion_documental: nota,
        calificacion_cuantitativa: nota,
        calificacion_opinion: nota
      }
    })

  if (evaluacionesPayload.length === 0) {
    mostrarError('Ingrese al menos una nota antes de guardar.')
    return
  }

  guardandoNotas.value = true

  const resultado = await evaluacionesStore.guardarBulk({
    id_version: idVersion,
    id_ejecucion: idProcesoSeleccionado.value,
    id_usuario: Number(idUsuario.value),
    fecha_evaluacion: hoy,
    observaciones: '-',
    justificacion: '-',
    evaluaciones: evaluacionesPayload
  })

  // Preservar las notas de indicadores con error antes de recargar del servidor
  const idsConError = new Set(resultado.errores.map(e => e.id_indicador))
  const notasFallidas: Record<number, number> = {}
  for (const id of idsConError) {
    if (notasLocales.value[id] != null) notasFallidas[id] = notasLocales.value[id]!
  }

  await evaluacionesStore.cargar({ id_version: idVersion })
  llenarNotasLocales()

  // Restaurar notas que no se guardaron para que el usuario pueda reintentar
  for (const [id, nota] of Object.entries(notasFallidas)) {
    notasLocales.value[Number(id)] = nota
  }

  guardandoNotas.value = false

  if (!resultado.ok) {
    mostrarError('No se pudieron guardar las calificaciones. Intente de nuevo.')
    return
  }

  if (resultado.errores.length) {
    mostrarError('Algunas calificaciones no se pudieron guardar. Verifique sus asignaciones e intente de nuevo.')
    return
  }

  // Verificar que todas las notas enviadas quedaron registradas
  const todasConfirmadas = evaluacionesPayload.every(
    e => evaluacionPorIndicador.value[e.id_indicador] != null
  )
  if (todasConfirmadas) {
    guardadoFinal.value = indicadoresInline.every(
      ind => evaluacionPorIndicador.value[ind.id_indicador!] != null
    )
  }
  mostrarExito('Calificaciones guardadas correctamente.')
}

function salir() {
  router.push({ name: 'ProcesoAutoevaluacionUsuario' })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LoadingOverlay, {
      visible: loading.value || guardandoNotas.value,
      message: guardandoNotas.value ? 'Guardando calificaciones, esto puede tardar un momento...' : 'Cargando indicadores...'
    }, null, 8, ["visible", "message"]),
    _createVNode(MensajeFlotante, {
      visible: mensajeVisible.value,
      mensaje: mensajeTexto.value,
      tipo: mensajeTipo.value,
      onCerrar: _cache[0] || (_cache[0] = ($event: any) => (mensajeVisible.value = false))
    }, null, 8, ["visible", "mensaje", "tipo"]),
    (!loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _cache[8] || (_cache[8] = _createElementVNode("h1", null, "Calificar Indicadores", -1)),
              (nombreVersion.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(nombreVersion.value), 1))
                : _createCommentVNode("", true),
              (tieneIndicadoresInline.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Rango de calificación: " + _toDisplayString(escalaMin.value) + " – " + _toDisplayString(escalaMax.value), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_6, [
              (tieneIndicadoresInline.value && !guardadoFinal.value && !todasLasNotasInlineRegistradas.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn guardar",
                    disabled: guardandoNotas.value,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (modalConfirmVisible.value = true))
                  }, _toDisplayString(guardandoNotas.value ? 'Guardando...' : 'Guardar'), 9, _hoisted_7))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "btn salir",
                onClick: salir
              }, "Salir")
            ])
          ]),
          (procesosEnEvaluacion.value.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (idProcesoSeleccionado.value === null)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[9] || (_cache[9] = _createElementVNode("p", { class: "selector-aviso" }, "Esta versión del modelo está activa en varios procesos. Seleccione el proceso que desea calificar:", -1)),
                      _createElementVNode("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(procesosEnEvaluacion.value, (p) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: p.id,
                            class: "proceso-card",
                            onClick: ($event: any) => (seleccionarProceso(p.id!))
                          }, [
                            _createElementVNode("span", _hoisted_11, _toDisplayString(p.area?.nombre ?? p.area?.programa ?? `Programa #${p.id_programa}`), 1),
                            _createElementVNode("span", _hoisted_12, _toDisplayString(p.periodo), 1)
                          ], 8, _hoisted_10))
                        }), 128))
                      ])
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("span", null, [
                        _cache[10] || (_cache[10] = _createTextVNode("Calificando: ")),
                        _createElementVNode("strong", null, _toDisplayString(procesoSeleccionado.value?.area?.nombre ?? procesoSeleccionado.value?.area?.programa ?? `Proceso #${idProcesoSeleccionado.value}`), 1),
                        _createTextVNode(" · " + _toDisplayString(procesoSeleccionado.value?.periodo), 1)
                      ]),
                      _createElementVNode("button", {
                        class: "btn-cambiar-proceso",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (idProcesoSeleccionado.value = null))
                      }, "Cambiar proceso")
                    ]))
              ]))
            : _createCommentVNode("", true),
          (!loading.value && _unref(procesosStore).procesos.length > 0 && procesosEnEvaluacion.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, " No hay procesos en estado Evaluación para esta versión. Las calificaciones no se pueden guardar hasta que el proceso cambie de estado. "))
            : _createCommentVNode("", true),
          (!loading.value && arbolParaVista.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                (opcionesN1.value.length > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("label", _hoisted_17, _toDisplayString(nivelesArray.value[0] ?? 'Factor') + ":", 1),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filtroN1).value = $event)),
                        class: "filtro-select",
                        onChange: onCambioN1
                      }, [
                        _cache[11] || (_cache[11] = _createElementVNode("option", { value: null }, "Todos", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opcionesN1.value, (nombre) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: nombre,
                            value: nombre
                          }, _toDisplayString(nombre), 9, _hoisted_18))
                        }), 128))
                      ], 544), [
                        [_vModelSelect, filtroN1.value]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (opcionesN2.value.length > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("label", _hoisted_20, _toDisplayString(nivelesArray.value[1] ?? 'Característica') + ":", 1),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filtroN2).value = $event)),
                        class: "filtro-select"
                      }, [
                        _cache[12] || (_cache[12] = _createElementVNode("option", { value: null }, "Todos", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opcionesN2.value, (nombre) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: nombre,
                            value: nombre
                          }, _toDisplayString(nombre), 9, _hoisted_21))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, filtroN2.value]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (filtroN1.value || filtroN2.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      class: "filtro-limpiar",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => {filtroN1.value = null; filtroN2.value = null})
                    }, " Limpiar filtros "))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_22, [
            (todosLosIndicadores.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, _cache[13] || (_cache[13] = [
                  _createElementVNode("p", null, "No hay indicadores disponibles para calificar en esta versión.", -1)
                ])))
              : (arbolFiltrado.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, _cache[14] || (_cache[14] = [
                    _createElementVNode("p", null, "No hay indicadores para el filtro seleccionado.", -1)
                  ])))
                : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(arbolFiltrado.value, (n1, i1) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i1,
                class: _normalizeClass(filtroN2.value ? 'nivel-transparente' : 'nivel-1-card')
              }, [
                (!filtroN2.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("span", _hoisted_26, _toDisplayString(nivelesArray.value[0] ?? 'Factor'), 1),
                      _createElementVNode("span", _hoisted_27, _toDisplayString(n1.ordinal || (i1 + 1)) + ".", 1),
                      _createElementVNode("span", _hoisted_28, _toDisplayString(n1.nombre), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(filtroN2.value ? 'nivel-transparente' : 'nivel-body')
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(n1.indicadores, (indicador) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: indicador.id_indicador,
                      class: "indicador-card"
                    }, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          (!mismoNombrePorIndicador.value[indicador.id_indicador])
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _cache[15] || (_cache[15] = _createElementVNode("span", { class: "indicador-tipo-badge" }, "Indicador", -1)),
                                _createElementVNode("h3", _hoisted_31, _toDisplayString(indicador.enunciado ?? indicador.nombre), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock("p", _hoisted_32, _toDisplayString(nombreComponentePorIndicador.value[indicador.id_indicador!]), 1))
                        ]),
                        (!mismoNombrePorIndicador.value[indicador.id_indicador])
                          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                              (indicador.unidades)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_34, [
                                    _cache[16] || (_cache[16] = _createElementVNode("span", { class: "info-label" }, "Unidades: ", -1)),
                                    _createElementVNode("span", _hoisted_35, _toDisplayString(indicador.unidades), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (indicador.formula)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_36, [
                                    _cache[17] || (_cache[17] = _createElementVNode("span", { class: "info-label" }, "Fórmula: ", -1)),
                                    _createElementVNode("span", _hoisted_37, _toDisplayString(indicador.formula), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (indicador.fuente_informacion)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_38, [
                                    _cache[18] || (_cache[18] = _createElementVNode("span", { class: "info-label" }, "Fuente: ", -1)),
                                    _createElementVNode("span", _hoisted_39, _toDisplayString(indicador.fuente_informacion), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        (mismoNombrePorIndicador.value[indicador.id_indicador])
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (guardadoFinal.value || (evaluacionPorIndicador.value[indicador.id_indicador] != null && !indicadoresEnEdicion.value.includes(indicador.id_indicador!)))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                    _cache[19] || (_cache[19] = _createElementVNode("span", { class: "nota-inline-label" }, "Nota registrada", -1)),
                                    _createElementVNode("input", {
                                      type: "number",
                                      class: "nota-inline-input",
                                      value: evaluacionPorIndicador.value[indicador.id_indicador] ?? 0,
                                      disabled: ""
                                    }, null, 8, _hoisted_42),
                                    (!guardadoFinal.value)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          type: "button",
                                          class: "btn guardar btn-modificar-inline",
                                          onClick: ($event: any) => (habilitarEdicionInline(indicador.id_indicador!))
                                        }, "Modificar", 8, _hoisted_43))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (indicadoresEnEdicion.value.includes(indicador.id_indicador!))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                      _cache[20] || (_cache[20] = _createElementVNode("span", { class: "nota-inline-label" }, "Modificar nota", -1)),
                                      _withDirectives(_createElementVNode("input", {
                                        type: "number",
                                        min: escalaMin.value,
                                        max: escalaMax.value,
                                        step: "0.1",
                                        "onUpdate:modelValue": ($event: any) => ((notasLocales.value[indicador.id_indicador!]) = $event),
                                        class: "nota-inline-input",
                                        placeholder: `${escalaMin.value} - ${escalaMax.value}`,
                                        onChange: ($event: any) => (clampNota(indicador.id_indicador!))
                                      }, null, 40, _hoisted_45), [
                                        [
                                          _vModelText,
                                          notasLocales.value[indicador.id_indicador!],
                                          void 0,
                                          { number: true }
                                        ]
                                      ]),
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "btn guardar btn-modificar-inline",
                                        disabled: guardandoModificacion.value,
                                        onClick: ($event: any) => (guardarModificacionInline(indicador))
                                      }, _toDisplayString(guardandoModificacion.value ? 'Guardando...' : 'Guardar'), 9, _hoisted_46)
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                      _cache[21] || (_cache[21] = _createElementVNode("span", { class: "nota-inline-label" }, "Ingrese la nota", -1)),
                                      _withDirectives(_createElementVNode("input", {
                                        type: "number",
                                        min: escalaMin.value,
                                        max: escalaMax.value,
                                        step: "0.1",
                                        "onUpdate:modelValue": ($event: any) => ((notasLocales.value[indicador.id_indicador!]) = $event),
                                        class: "nota-inline-input",
                                        placeholder: `${escalaMin.value} - ${escalaMax.value}`,
                                        onChange: ($event: any) => (clampNota(indicador.id_indicador!))
                                      }, null, 40, _hoisted_48), [
                                        [
                                          _vModelText,
                                          notasLocales.value[indicador.id_indicador!],
                                          void 0,
                                          { number: true }
                                        ]
                                      ])
                                    ]))
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["nota-etiqueta", indicador.id_indicador !== undefined && evaluacionPorIndicador.value[indicador.id_indicador] != null ? 'calificado' : 'pendiente'])
                              }, [
                                (indicador.id_indicador !== undefined && evaluacionPorIndicador.value[indicador.id_indicador] != null)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _cache[22] || (_cache[22] = _createElementVNode("span", { class: "nota-etiqueta-titulo" }, "NOTA", -1)),
                                      _createElementVNode("span", _hoisted_49, _toDisplayString((evaluacionPorIndicador.value[indicador.id_indicador] as number).toFixed(2)), 1)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _cache[23] || (_cache[23] = _createElementVNode("span", { class: "nota-etiqueta-linea" }, "Pendiente", -1)),
                                      _cache[24] || (_cache[24] = _createElementVNode("span", { class: "nota-etiqueta-linea" }, "de", -1)),
                                      _cache[25] || (_cache[25] = _createElementVNode("span", { class: "nota-etiqueta-linea" }, "calificación", -1))
                                    ], 64))
                              ], 2),
                              (indicador.id_indicador === undefined || evaluacionPorIndicador.value[indicador.id_indicador] == null)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "btn calificar",
                                    disabled: procesosEnEvaluacion.value.length > 0 && idProcesoSeleccionado.value === null,
                                    onClick: ($event: any) => (onCalificarIndicador(indicador))
                                  }, "Calificar", 8, _hoisted_50))
                                : _createCommentVNode("", true),
                              (indicador.id_indicador !== undefined && evaluacionPorIndicador.value[indicador.id_indicador] != null)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    class: "btn guardar btn-modificar-modal",
                                    disabled: procesosEnEvaluacion.value.length > 0 && idProcesoSeleccionado.value === null,
                                    onClick: ($event: any) => (onCalificarIndicador(indicador))
                                  }, "Modificar", 8, _hoisted_51))
                                : _createCommentVNode("", true)
                            ], 64))
                      ])
                    ]))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(n1.hijos, (n2, i2) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i2,
                      class: "nivel-2-card"
                    }, [
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("span", _hoisted_53, _toDisplayString(nivelesArray.value[1] ?? 'Característica'), 1),
                        _createElementVNode("span", _hoisted_54, _toDisplayString(n2.ordinal || `${i1 + 1}.${i2 + 1}`) + ".", 1),
                        _createElementVNode("span", _hoisted_55, _toDisplayString(n2.nombre), 1)
                      ]),
                      _createElementVNode("div", _hoisted_56, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(n2.indicadores, (indicador) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: indicador.id_indicador,
                            class: "indicador-card"
                          }, [
                            _createElementVNode("div", _hoisted_57, [
                              _createElementVNode("div", _hoisted_58, [
                                (!mismoNombrePorIndicador.value[indicador.id_indicador])
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _cache[26] || (_cache[26] = _createElementVNode("span", { class: "indicador-tipo-badge" }, "Indicador", -1)),
                                      _createElementVNode("h3", _hoisted_59, _toDisplayString(indicador.enunciado ?? indicador.nombre), 1)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock("p", _hoisted_60, _toDisplayString(nombreComponentePorIndicador.value[indicador.id_indicador!]), 1))
                              ]),
                              (!mismoNombrePorIndicador.value[indicador.id_indicador])
                                ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                    (indicador.unidades)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_62, [
                                          _cache[27] || (_cache[27] = _createElementVNode("span", { class: "info-label" }, "Unidades: ", -1)),
                                          _createElementVNode("span", _hoisted_63, _toDisplayString(indicador.unidades), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (indicador.formula)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_64, [
                                          _cache[28] || (_cache[28] = _createElementVNode("span", { class: "info-label" }, "Fórmula: ", -1)),
                                          _createElementVNode("span", _hoisted_65, _toDisplayString(indicador.formula), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (indicador.fuente_informacion)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_66, [
                                          _cache[29] || (_cache[29] = _createElementVNode("span", { class: "info-label" }, "Fuente: ", -1)),
                                          _createElementVNode("span", _hoisted_67, _toDisplayString(indicador.fuente_informacion), 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_68, [
                              (mismoNombrePorIndicador.value[indicador.id_indicador])
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (guardadoFinal.value || (evaluacionPorIndicador.value[indicador.id_indicador] != null && !indicadoresEnEdicion.value.includes(indicador.id_indicador!)))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                          _cache[30] || (_cache[30] = _createElementVNode("span", { class: "nota-inline-label" }, "Nota registrada", -1)),
                                          _createElementVNode("input", {
                                            type: "number",
                                            class: "nota-inline-input",
                                            value: evaluacionPorIndicador.value[indicador.id_indicador] ?? 0,
                                            disabled: ""
                                          }, null, 8, _hoisted_70),
                                          (!guardadoFinal.value)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                type: "button",
                                                class: "btn guardar btn-modificar-inline",
                                                onClick: ($event: any) => (habilitarEdicionInline(indicador.id_indicador!))
                                              }, "Modificar", 8, _hoisted_71))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : (indicadoresEnEdicion.value.includes(indicador.id_indicador!))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                            _cache[31] || (_cache[31] = _createElementVNode("span", { class: "nota-inline-label" }, "Modificar nota", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                              type: "number",
                                              min: escalaMin.value,
                                              max: escalaMax.value,
                                              step: "0.1",
                                              "onUpdate:modelValue": ($event: any) => ((notasLocales.value[indicador.id_indicador!]) = $event),
                                              class: "nota-inline-input",
                                              placeholder: `${escalaMin.value} - ${escalaMax.value}`,
                                              onChange: ($event: any) => (clampNota(indicador.id_indicador!))
                                            }, null, 40, _hoisted_73), [
                                              [
                                                _vModelText,
                                                notasLocales.value[indicador.id_indicador!],
                                                void 0,
                                                { number: true }
                                              ]
                                            ]),
                                            _createElementVNode("button", {
                                              type: "button",
                                              class: "btn guardar btn-modificar-inline",
                                              disabled: guardandoModificacion.value,
                                              onClick: ($event: any) => (guardarModificacionInline(indicador))
                                            }, _toDisplayString(guardandoModificacion.value ? 'Guardando...' : 'Guardar'), 9, _hoisted_74)
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                            _cache[32] || (_cache[32] = _createElementVNode("span", { class: "nota-inline-label" }, "Ingrese la nota", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                              type: "number",
                                              min: escalaMin.value,
                                              max: escalaMax.value,
                                              step: "0.1",
                                              "onUpdate:modelValue": ($event: any) => ((notasLocales.value[indicador.id_indicador!]) = $event),
                                              class: "nota-inline-input",
                                              placeholder: `${escalaMin.value} - ${escalaMax.value}`,
                                              onChange: ($event: any) => (clampNota(indicador.id_indicador!))
                                            }, null, 40, _hoisted_76), [
                                              [
                                                _vModelText,
                                                notasLocales.value[indicador.id_indicador!],
                                                void 0,
                                                { number: true }
                                              ]
                                            ])
                                          ]))
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["nota-etiqueta", indicador.id_indicador !== undefined && evaluacionPorIndicador.value[indicador.id_indicador] != null ? 'calificado' : 'pendiente'])
                                    }, [
                                      (indicador.id_indicador !== undefined && evaluacionPorIndicador.value[indicador.id_indicador] != null)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _cache[33] || (_cache[33] = _createElementVNode("span", { class: "nota-etiqueta-titulo" }, "NOTA", -1)),
                                            _createElementVNode("span", _hoisted_77, _toDisplayString((evaluacionPorIndicador.value[indicador.id_indicador] as number).toFixed(2)), 1)
                                          ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _cache[34] || (_cache[34] = _createElementVNode("span", { class: "nota-etiqueta-linea" }, "Pendiente", -1)),
                                            _cache[35] || (_cache[35] = _createElementVNode("span", { class: "nota-etiqueta-linea" }, "de", -1)),
                                            _cache[36] || (_cache[36] = _createElementVNode("span", { class: "nota-etiqueta-linea" }, "calificación", -1))
                                          ], 64))
                                    ], 2),
                                    (indicador.id_indicador === undefined || evaluacionPorIndicador.value[indicador.id_indicador] == null)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          class: "btn calificar",
                                          disabled: procesosEnEvaluacion.value.length > 0 && idProcesoSeleccionado.value === null,
                                          onClick: ($event: any) => (onCalificarIndicador(indicador))
                                        }, "Calificar", 8, _hoisted_78))
                                      : _createCommentVNode("", true),
                                    (indicador.id_indicador !== undefined && evaluacionPorIndicador.value[indicador.id_indicador] != null)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 1,
                                          class: "btn guardar btn-modificar-modal",
                                          disabled: procesosEnEvaluacion.value.length > 0 && idProcesoSeleccionado.value === null,
                                          onClick: ($event: any) => (onCalificarIndicador(indicador))
                                        }, "Modificar", 8, _hoisted_79))
                                      : _createCommentVNode("", true)
                                  ], 64))
                            ])
                          ]))
                        }), 128)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(n2.hijos, (n3, i3) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: i3,
                            class: "nivel-3-card"
                          }, [
                            _createElementVNode("div", _hoisted_80, [
                              _createElementVNode("span", _hoisted_81, _toDisplayString(nivelesArray.value[2] ?? 'Aspecto'), 1),
                              _createElementVNode("span", _hoisted_82, _toDisplayString(n3.ordinal || `${i1 + 1}.${i2 + 1}.${i3 + 1}`) + ".", 1),
                              _createElementVNode("span", _hoisted_83, _toDisplayString(n3.nombre), 1)
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(n3.indicadores, (indicador) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: indicador.id_indicador,
                                class: "indicador-card"
                              }, [
                                _createElementVNode("div", _hoisted_84, [
                                  _createElementVNode("div", _hoisted_85, [
                                    (!mismoNombrePorIndicador.value[indicador.id_indicador])
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _cache[37] || (_cache[37] = _createElementVNode("span", { class: "indicador-tipo-badge" }, "Indicador", -1)),
                                          _createElementVNode("h3", _hoisted_86, _toDisplayString(indicador.enunciado ?? indicador.nombre), 1)
                                        ], 64))
                                      : (_openBlock(), _createElementBlock("p", _hoisted_87, _toDisplayString(nombreComponentePorIndicador.value[indicador.id_indicador!]), 1))
                                  ]),
                                  (!mismoNombrePorIndicador.value[indicador.id_indicador])
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                        (indicador.unidades)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_89, [
                                              _cache[38] || (_cache[38] = _createElementVNode("span", { class: "info-label" }, "Unidades: ", -1)),
                                              _createElementVNode("span", _hoisted_90, _toDisplayString(indicador.unidades), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (indicador.formula)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_91, [
                                              _cache[39] || (_cache[39] = _createElementVNode("span", { class: "info-label" }, "Fórmula: ", -1)),
                                              _createElementVNode("span", _hoisted_92, _toDisplayString(indicador.formula), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (indicador.fuente_informacion)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_93, [
                                              _cache[40] || (_cache[40] = _createElementVNode("span", { class: "info-label" }, "Fuente: ", -1)),
                                              _createElementVNode("span", _hoisted_94, _toDisplayString(indicador.fuente_informacion), 1)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_95, [
                                  (mismoNombrePorIndicador.value[indicador.id_indicador])
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (guardadoFinal.value || (evaluacionPorIndicador.value[indicador.id_indicador] != null && !indicadoresEnEdicion.value.includes(indicador.id_indicador!)))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                                              _cache[41] || (_cache[41] = _createElementVNode("span", { class: "nota-inline-label" }, "Nota registrada", -1)),
                                              _createElementVNode("input", {
                                                type: "number",
                                                class: "nota-inline-input",
                                                value: evaluacionPorIndicador.value[indicador.id_indicador] ?? 0,
                                                disabled: ""
                                              }, null, 8, _hoisted_97),
                                              (!guardadoFinal.value)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    type: "button",
                                                    class: "btn guardar btn-modificar-inline",
                                                    onClick: ($event: any) => (habilitarEdicionInline(indicador.id_indicador!))
                                                  }, "Modificar", 8, _hoisted_98))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : (indicadoresEnEdicion.value.includes(indicador.id_indicador!))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                                                _cache[42] || (_cache[42] = _createElementVNode("span", { class: "nota-inline-label" }, "Modificar nota", -1)),
                                                _withDirectives(_createElementVNode("input", {
                                                  type: "number",
                                                  min: escalaMin.value,
                                                  max: escalaMax.value,
                                                  step: "0.1",
                                                  "onUpdate:modelValue": ($event: any) => ((notasLocales.value[indicador.id_indicador!]) = $event),
                                                  class: "nota-inline-input",
                                                  placeholder: `${escalaMin.value} - ${escalaMax.value}`,
                                                  onChange: ($event: any) => (clampNota(indicador.id_indicador!))
                                                }, null, 40, _hoisted_100), [
                                                  [
                                                    _vModelText,
                                                    notasLocales.value[indicador.id_indicador!],
                                                    void 0,
                                                    { number: true }
                                                  ]
                                                ]),
                                                _createElementVNode("button", {
                                                  type: "button",
                                                  class: "btn guardar btn-modificar-inline",
                                                  disabled: guardandoModificacion.value,
                                                  onClick: ($event: any) => (guardarModificacionInline(indicador))
                                                }, _toDisplayString(guardandoModificacion.value ? 'Guardando...' : 'Guardar'), 9, _hoisted_101)
                                              ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_102, [
                                                _cache[43] || (_cache[43] = _createElementVNode("span", { class: "nota-inline-label" }, "Ingrese la nota", -1)),
                                                _withDirectives(_createElementVNode("input", {
                                                  type: "number",
                                                  min: escalaMin.value,
                                                  max: escalaMax.value,
                                                  step: "0.1",
                                                  "onUpdate:modelValue": ($event: any) => ((notasLocales.value[indicador.id_indicador!]) = $event),
                                                  class: "nota-inline-input",
                                                  placeholder: `${escalaMin.value} - ${escalaMax.value}`,
                                                  onChange: ($event: any) => (clampNota(indicador.id_indicador!))
                                                }, null, 40, _hoisted_103), [
                                                  [
                                                    _vModelText,
                                                    notasLocales.value[indicador.id_indicador!],
                                                    void 0,
                                                    { number: true }
                                                  ]
                                                ])
                                              ]))
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["nota-etiqueta", indicador.id_indicador !== undefined && evaluacionPorIndicador.value[indicador.id_indicador] != null ? 'calificado' : 'pendiente'])
                                        }, [
                                          (indicador.id_indicador !== undefined && evaluacionPorIndicador.value[indicador.id_indicador] != null)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _cache[44] || (_cache[44] = _createElementVNode("span", { class: "nota-etiqueta-titulo" }, "NOTA", -1)),
                                                _createElementVNode("span", _hoisted_104, _toDisplayString((evaluacionPorIndicador.value[indicador.id_indicador] as number).toFixed(2)), 1)
                                              ], 64))
                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _cache[45] || (_cache[45] = _createElementVNode("span", { class: "nota-etiqueta-linea" }, "Pendiente", -1)),
                                                _cache[46] || (_cache[46] = _createElementVNode("span", { class: "nota-etiqueta-linea" }, "de", -1)),
                                                _cache[47] || (_cache[47] = _createElementVNode("span", { class: "nota-etiqueta-linea" }, "calificación", -1))
                                              ], 64))
                                        ], 2),
                                        (indicador.id_indicador === undefined || evaluacionPorIndicador.value[indicador.id_indicador] == null)
                                          ? (_openBlock(), _createElementBlock("button", {
                                              key: 0,
                                              class: "btn calificar",
                                              disabled: procesosEnEvaluacion.value.length > 0 && idProcesoSeleccionado.value === null,
                                              onClick: ($event: any) => (onCalificarIndicador(indicador))
                                            }, "Calificar", 8, _hoisted_105))
                                          : _createCommentVNode("", true),
                                        (indicador.id_indicador !== undefined && evaluacionPorIndicador.value[indicador.id_indicador] != null)
                                          ? (_openBlock(), _createElementBlock("button", {
                                              key: 1,
                                              class: "btn guardar btn-modificar-modal",
                                              disabled: procesosEnEvaluacion.value.length > 0 && idProcesoSeleccionado.value === null,
                                              onClick: ($event: any) => (onCalificarIndicador(indicador))
                                            }, "Modificar", 8, _hoisted_106))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                ])
                              ]))
                            }), 128))
                          ]))
                        }), 128))
                      ])
                    ]))
                  }), 128))
                ], 2)
              ], 2))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_107, [
            (tieneIndicadoresInline.value && !guardadoFinal.value && !todasLasNotasInlineRegistradas.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn guardar",
                  disabled: guardandoNotas.value,
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (modalConfirmVisible.value = true))
                }, _toDisplayString(guardandoNotas.value ? 'Guardando...' : 'Guardar'), 9, _hoisted_108))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "btn salir",
              onClick: salir
            }, "Salir")
          ])
        ]))
      : _createCommentVNode("", true),
    (modalConfirmVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
          _createElementVNode("div", _hoisted_110, [
            _cache[48] || (_cache[48] = _createElementVNode("h3", { class: "modal-confirm-titulo" }, "¿Confirmar guardado?", -1)),
            _cache[49] || (_cache[49] = _createElementVNode("p", { class: "modal-confirm-mensaje" }, " Se guardarán las notas ingresadas. Los aspectos sin nota no se modificarán y podrá completarlos después. ", -1)),
            _createElementVNode("div", _hoisted_111, [
              _createElementVNode("button", {
                class: "btn salir",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (modalConfirmVisible.value = false))
              }, "Cancelar"),
              _createElementVNode("button", {
                class: "btn guardar",
                onClick: confirmarGuardar
              }, "Confirmar")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (modalIndicadorVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
          _createElementVNode("div", _hoisted_113, [
            _createElementVNode("div", { class: "modal-header-bar" }, [
              _createElementVNode("button", {
                class: "modal-cerrar",
                onClick: cerrarModalIndicador
              }, "×")
            ]),
            _createElementVNode("div", _hoisted_114, [
              _createVNode(CalificarIndicadorUnificadoModal, {
                idVersion: _unref(idVersion),
                idIndicador: indicadorSeleccionado.value!,
                idEjecucion: idProcesoSeleccionado.value ?? undefined,
                escalaMax: escalaMax.value,
                onCerrar: cerrarModalIndicador
              }, null, 8, ["idVersion", "idIndicador", "idEjecucion", "escalaMax"])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})